import styled from 'styled-components'

export const ZoneItemContainer = styled.div<{ $expanded: boolean }>`
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.background.primary};
  overflow: hidden;
  transition: all ${({ theme }) => theme.transitions.default};

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.focus};
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`

export const ZoneHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.medium};
  cursor: pointer;
  user-select: none;
  transition: background-color ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }
`

export const ZoneHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.micro};
  flex: 1;
`

export const ZoneTitle = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`

export const ZoneMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ZoneTypeChip = styled.div`
  display: inline-flex;
`

export const ZoneDetails = styled.div<{ $expanded: boolean }>`
  max-height: ${({ $expanded }) => ($expanded ? '1000px' : '0')};
  opacity: ${({ $expanded }) => ($expanded ? '1' : '0')};
  overflow: hidden;
  transition:
    max-height ${({ theme }) => theme.transitions.medium},
    opacity ${({ theme }) => theme.transitions.default};
`

export const ZoneDetailsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  padding: 0 ${({ theme }) => theme.spacing.medium}
    ${({ theme }) => theme.spacing.medium};
  border-top: 1px solid ${({ theme }) => theme.colors.border.light};
  padding-top: ${({ theme }) => theme.spacing.medium};
`
